import api from '../index';

export interface CreateBrandPayload {
  name: string;
}

export interface UpdateBrandPayload {
  name?: string;
  isTestBrand?: boolean;
  avatarPictureAwsTempUrl?: string;
  walmartConnectAdvertiserAdvertiserId?: string;
}

const brandUpdaters = {
  createBrand: async ({
    agencyId,
    data,
  }: {
    agencyId: string;
    data: CreateBrandPayload;
  }) =>
    api.post(`/organizations/${agencyId}/brands`, data, {
      params: {include: 'agency.subscription.levers'},
    }),

  updateBrand: async ({
    agencyId,
    brandId,
    data,
  }: {
    agencyId: string;
    brandId: string;
    data: UpdateBrandPayload;
  }) => api.patch(`/organizations/${agencyId}/brands/${brandId}`, data),
};

export default brandUpdaters;
